import { useQuery } from "@tanstack/react-query";
import { OfferService } from "@/generated/services/OfferService";
import { offer } from "@/generated";
import { OpenAPI } from "@/generated/core/OpenAPI";
import { request as __request } from "@/generated/core/request";

const NUMERIC_ID = /^\d+$/;

export function useFetchOffer(
  offerIdOrRef: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["offer", offerIdOrRef],
    queryFn: async () => {
      const retailerId = Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0;

      // Numeric input → standard /offers/{offer_id} lookup.
      // Non-numeric input → treat as offer_ref; backend expects offer_id=0
      // in the path and the ref in the offer_ref query param.
      if (NUMERIC_ID.test(offerIdOrRef)) {
        const response = await OfferService.getOffers1(
          Number(offerIdOrRef),
          undefined,
          retailerId,
        );
        return response as unknown as offer;
      }

      const response = await __request(OpenAPI, {
        method: "GET",
        url: "/offers/{offer_id}",
        path: { offer_id: 0 },
        query: { offer_ref: offerIdOrRef, retailer_id: retailerId },
      });
      return response as unknown as offer;
    },
    enabled: options?.enabled !== false && !!offerIdOrRef,
    gcTime: 0, // Don't cache the response
    staleTime: 0, // Always consider data stale to refetch
  });
}
